module.exports = __webpack_public_path__ + "img/5.74717d84.jpg";